import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components

import withStyles from "@material-ui/core/styles/withStyles";
import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div>
      <GridContainer className={classNames(classes.aboutDescription)}>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto, classes.textCenter)}
        >
          <h2 className={classes.description}>
            Whether you're planning to sell, rent or are undecided, we have an expert who can help.
          </h2>
          <h3>What's your property worth?</h3>
          <h5>
            Get specialist advice for commercial, residential or rural property, grounded in our experience and knowledge of local, regional and international markets.
          </h5>
          <h5>With specialists and partners working across all property sectors, we are able to advise all types assets.</h5>
        </GridItem>

        <GridItem md={8}
        sm={8} className={classNames(classes.mrAuto, classes.mlAuto)}>
          <h3 className={classNames(classes.aboutDescription, classes.textCenter)}>Defining Your Investment Criteria</h3>
          <h5 className={classNames(classes.aboutDescription)}>
            Defining your investment criteria is a vital early step to building a successful real estate portfolio or to buy  companies.
             If you can determine what it is you are looking for and clearly communicate it to our team, you will save everyone time and effort and will have better investment outcomes.

          The goal is you should be able to sum up what you are looking for in a few concise sentences. In this way we can to generate more opportunities and proposal of investment for you.
        </h5>
        <h5>
           Find new business opportunities Deal Sourcing
          Investors, Corporates, Funds and Private equity firms have to be able to find good businesses at great prices, do something good with them along with management while they own them, and then know when it’s time to sell. Sourcing is the first critical step and Kinos are laser focused on how GPs source,”.
        </h5>
        <h5>
          When we know your criteria investment Kinos put the specialized business development professional at your service. Over the years, private equity firms have realized that it’s far more efficient to have a dedicated person or team to cultivate relationships and find the right deal flow.
          </h5>
          <h5>
          We help clients looking to invest in Spain, Portugal or overseas achieve the very best returns, approaching every challenge that they face with a fully integrated outlook.
          </h5>

        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
